import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none",
  viewBox: "0 0 14 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.001 13.335a5.833 5.833 0 1 1 0-11.667 5.833 5.833 0 0 1 0 11.667m0-1.167a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333m-.583-7.583h1.167V5.75H6.418zm0 2.333h1.167v3.5H6.418z"
    }, null, -1)
  ]))]))
}
export default { render: render }